// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DtaSuggestionsResponse
 */
export interface DtaSuggestionsResponse {
    /**
     * 
     * @type {string}
     * @memberof DtaSuggestionsResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof DtaSuggestionsResponse
     */
    status: DtaSuggestionsResponseStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof DtaSuggestionsResponse
     */
    suggestions: object | null;
}


/**
 * @export
 */
export const DtaSuggestionsResponseStatusEnum = {
    Ready: 'ready',
    Generating: 'generating',
    Unavailable: 'unavailable',
    Error: 'error'
} as const;
export type DtaSuggestionsResponseStatusEnum = typeof DtaSuggestionsResponseStatusEnum[keyof typeof DtaSuggestionsResponseStatusEnum];


/**
 * Check if a given object implements the DtaSuggestionsResponse interface.
 */
export function instanceOfDtaSuggestionsResponse(value: object): value is DtaSuggestionsResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    return true;
}

export function DtaSuggestionsResponseFromJSON(json: any): DtaSuggestionsResponse {
    return DtaSuggestionsResponseFromJSONTyped(json, false);
}

export function DtaSuggestionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DtaSuggestionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'status': json['status'],
        'suggestions': json['suggestions'],
    };
}

export function DtaSuggestionsResponseToJSON(json: any): DtaSuggestionsResponse {
    return DtaSuggestionsResponseToJSONTyped(json, false);
}

export function DtaSuggestionsResponseToJSONTyped(value?: DtaSuggestionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'status': value['status'],
        'suggestions': value['suggestions'],
    };
}
